enum UserNotificationGroup {
  ALL = 'ALL',
  WORK_TIME_RECORD = 'WORK_TIME_RECORD',
  FINANCE = 'FINANCE',
  GENERAL = 'GENERAL',
}

export { UserNotificationGroup };
